import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[modal-wrapper]',
    standalone: true
})
export class DynamicModalDirective {
  viewContainerRef = inject(ViewContainerRef);
}
